export default {
  tr_send: 'Send',
  tr_confirm: 'Payment confirmation',
  tr_operation_confirm: 'Operation confirmation',
  tr_recipient_not_found: 'Recipient not found',
  tr_pay_fee_for_rec: 'Pay fee for recipient',
  tr_successful: 'Payment successful',
  tr_no_assets: 'No transferable assets in your wallet',
  tr_no_assets_exp: 'This feature will be available once you have any transferable asset',
  tr_no_assets_exists: 'No assets exists in the system',
  tr_no_assets_exists_exp: 'This feature will be available once  any asset appears',
  tr_balance: 'Your balance is %{balance} %{token}',
  tr_create_mass: 'Make a mass payment',
  tr_mass_about: 'Upload .csv file with receivers email or account ID, indicate amount and asset. Please enter each receiver info in new line.',
  tr_tell_me_more: 'Tell me more',
  tr_about_csv: 'About .csv',
  tr_how_to_create_csv: 'How to create .CSV file',
  tr_mass_about_detailed: 'In CSV-format data fields are often separated, by a comma. For example, the spreadsheet you may want to upload:',
  tr_should_look_like: 'should look like:',
  tr_use_editor: 'Also, it\'s a good way to use export .csv from text editor, such as Notepad, Microsoft Excel, OpenOffice Calc, or Google Docs.',
  tr_total_amount: 'Total amount',
  tr_total_source_fee: 'Total sender fee',
  tr_total_recipient_fee: 'Total recipients fee',
  tr_mass_payment_details: 'Here what you will pay:',
  tr_mass_payment_failed: 'One or more operations are not valid. Please review them and try again',
  tr_less_than_fee: 'Amount is less than required for a fees payment',
  tr_greater_than_balance: 'Amount is greater than existing balance',
  tr_sending_error: 'Transfer error',
  tr_current_recipient_not_found: 'recipient %{recipient} not found',
  tr_transfer_balance: 'Balance is %{amount} %{asset}.',
  tr_found_errors: 'Found errors',
  tr_not_valid_file: 'Operation failed, uploaded file\'s data are not valid',
  tr_digital_values: 'Digital values',
  tr_no_digital_values: 'Not available',
  tr_digital_values_for: 'for',
  tr_conformation_buing_sertificate: 'Please confirm a purchase of %{amountX} %{currencyX} certificate for %{amountY} %{currencyY}',
  tr_greater_amount_and_commissions: 'Amount with commissions is greater than existing balance'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/transfers_view.js